/** Legacy Breitling-compatible quote URL with preserved Service Details return context (`q`). */
export function buildServiceQuotePath(
  repairNumber: string,
  quoteId: string,
  returnContext: string
): string {
  const repair = encodeURIComponent(repairNumber);
  const quote = encodeURIComponent(quoteId);
  const q = encodeURIComponent(returnContext);
  return `/service/quote/${repair}/${quote}/?q=${q}`;
}
